module.exports = __webpack_public_path__ + "static/img/img3.349375c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202309/img3.jpg
// module id = JEzs
// module chunks = 0